import { Link } from "@tanstack/react-router";
import { Lock } from "lucide-react";

import { MapPreviewImage } from "#/components/MapPreviewImage";
import { PageShell } from "#/components/PageShell";
import { Button } from "#/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "#/components/ui/card";
import { MAP_ACCESS_UPSELL_COPY, type MapAccessUpsellReason } from "#/lib/mapAccessUpsellCopy";
import { HERO_PREVIEW_BOX_PX } from "#/routes/-play.previewSizing";

export function PlayMapAccessGate({
  reason,
  mapId,
}: {
  reason: MapAccessUpsellReason;
  mapId: string;
}) {
  const copy = MAP_ACCESS_UPSELL_COPY[reason];

  return (
    <PageShell>
      <div className="flex justify-center">
        <Card className="w-full max-w-sm">
          <CardHeader>
            <CardTitle>{copy.title}</CardTitle>
            <CardDescription>{copy.description}</CardDescription>
          </CardHeader>
          <CardContent>
            <PlayMapAccessPreview mapId={mapId} />
          </CardContent>
          <CardFooter>
            <Link to="/premium" preload={false} className="w-full">
              <Button size="lg" variant="premium" className="w-full">
                <Lock className="mr-2 size-4" aria-hidden />
                Upgrade
              </Button>
            </Link>
          </CardFooter>
        </Card>
      </div>
    </PageShell>
  );
}

function PlayMapAccessPreview({ mapId }: { mapId: string }) {
  return (
    <MapPreviewImage
      mapId={mapId}
      maxSize={HERO_PREVIEW_BOX_PX}
      className="overflow-hidden border border-border"
    />
  );
}
